import { useCallback, useState } from 'react';

import { ActivityBuilderModal } from 'approot/activity-builder/activity-builder-modal';
import {
  SettingsGroup,
  SettingsLabel,
} from 'approot/activity-builder/settings/settings.style';
import { PrimaryButton } from 'approot/shared/styles/buttons/primary-button';
import { FileDropperContextProvider } from 'lib/form/file-dropper/file-dropper.context';
import { SimpleModalVerticalActionsStyled } from 'lib/modal/simple-modal.styles';
import { FileDropper } from 'lib/form/file-dropper/file-dropper';
import { ACCEPT_TYPE_AUDIO } from 'lib/form/file-dropper/file-dropper.constants';
import { Box } from 'approot/shared/design-system/box/box.style';
import { SmallStyled } from 'approot/shared/styles/typography.style';

type Props = {
  loading?: boolean;
  fileName: string | null;
  fileKey: string | null;
  original: string | null;
  closeModal: () => void;
  onUpdate: (
    props:
      | {
          key: string | null;
          fileName: string | null;
          original: string | null;
        }
      | undefined
  ) => void;
};

const ComponentAudioModal = ({
  loading,
  fileKey,
  fileName,
  original,
  closeModal,
  onUpdate,
}: Props) => {
  const [audioFile, setAudioFile] = useState<{
    key: string | null;
    fileName: string | null;
    original: string | null;
  } | null>(
    fileKey
      ? {
          key: fileKey,
          fileName: fileName,
          original: original,
        }
      : null
  );

  const handleFileChange = useCallback(
    (key: string, fileName: string) => {
      setAudioFile({ key, fileName, original });
    },
    [original, setAudioFile]
  );

  return (
    <>
      <ActivityBuilderModal
        isVisible
        size={640}
        title="Attach Sound"
        headerTitle="Attach Sound"
        onClose={closeModal}
      >
        <SettingsGroup>
          <Box $justifyContent="space-between">
            <SettingsLabel>Mp3 Sound File</SettingsLabel>
            <SmallStyled marginBottom={0}>Optional</SmallStyled>
          </Box>
          <FileDropper
            name="audio"
            value={audioFile?.fileName || undefined}
            source={audioFile?.original || undefined}
            accept={[ACCEPT_TYPE_AUDIO]}
            isFinishing={false}
            maxSizeInMb={3}
            onChange={handleFileChange}
            onFileRemoved={() => {
              setAudioFile(null);
            }}
          />
        </SettingsGroup>

        <SimpleModalVerticalActionsStyled>
          <PrimaryButton
            type="button"
            loading={loading}
            disabled={loading}
            onClick={() => {
              onUpdate(
                audioFile
                  ? {
                      key: audioFile.key,
                      fileName: audioFile.fileName,
                      original: audioFile.original,
                    }
                  : undefined
              );
            }}
            data-selector="btn-save-audio"
          >
            Save
          </PrimaryButton>
        </SimpleModalVerticalActionsStyled>
      </ActivityBuilderModal>
    </>
  );
};

const ComponentAudioModalWrapper = (props: Props) => (
  <FileDropperContextProvider>
    <ComponentAudioModal {...props} />
  </FileDropperContextProvider>
);

export default ComponentAudioModalWrapper;
